// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3r8BG","topBottomGutter":"Layout_topBottomGutter__YMcJf"};